<section class="min-h-screen flex items-center justify-center bg-gray-50 dark:bg-gray-900 px-4">
  <div class="w-full max-w-md rounded-2xl bg-white dark:bg-gray-800 shadow-lg p-6 text-center">
    <div class="mx-auto mb-4 w-14 h-14 rounded-full bg-red-100 dark:bg-red-900/30 flex items-center justify-center">
      <i-lucide name="ban" class="w-7 h-7 text-red-600"></i-lucide>
    </div>

    <h1 class="text-xl font-semibold text-gray-900 dark:text-gray-100">Acesso negado</h1>
    <p class="mt-2 text-sm text-gray-600 dark:text-gray-300">
      Você não possui permissão para acessar esta tela.
      Entre em contato com a secretaria para solicitar acesso.
    </p>

    <div class="mt-6">
      <button
        type="button"
        (click)="irParaContexto()"
        class="w-full rounded-lg bg-blue-600 dark:bg-blue-500 px-4 py-2 text-white font-medium hover:bg-blue-700 dark:hover:bg-blue-400 transition-colors"
      >
        Trocar contexto
      </button>
    </div>
  </div>
</section>

